import { cn } from 'lib/utils';

export const Card = ({ className, children }: any) => {
    return <div className={cn('bg-white rounded-lg border border-zinc-200 shadow-sm p-6', className)}>{children}</div>;
};

export const CardHeader = ({ className, children }: any) => {
    return <div className={cn('px-6 py-4 border-b border-zinc-100', className)}>{children}</div>;
};

export const CardContent = ({ className, children }: any) => {
    return <div className={cn('p-6', className)}>{children}</div>;
};

export const CardTitle = ({ className, children }: any) => {
    return <h3 className={cn('text-lg font-semibold text-zinc-700 mb-2', className)}>{children}</h3>;
};

export const CardDescription = ({ className, children }: any) => {
    return <p className={cn('text-sm text-zinc-500 mt-1', className)}>{children}</p>;
};

export const CardSubtitle = ({ className, children }: any) => {
    return <div className={cn('text-zinc-500 mb-8', className)}>{children}</div>;
};
